import { ReviewEntryQuestionSeverity } from '../enums/reviewEntryQuestionSeverity'
import type { ReviewEntryQuestion } from '../types/reviewEntryQuestion'

export const getQuestionSeverity = (question: ReviewEntryQuestion): string | undefined => {
  const severity = (question.level ?? question.severity)?.toLowerCase()

  // the ai-entries API sends `middle` for medium-severity questions while older payloads
  // use `medium` — normalize both to the enum value
  return severity === 'middle' ? ReviewEntryQuestionSeverity.Medium : severity
}

export const isAlertQuestion = (question: ReviewEntryQuestion): boolean => {
  const severity = getQuestionSeverity(question)

  return severity === ReviewEntryQuestionSeverity.High || severity === ReviewEntryQuestionSeverity.Medium
}

export const isHighQuestion = (question: ReviewEntryQuestion): boolean =>
  getQuestionSeverity(question) === ReviewEntryQuestionSeverity.High

export const isMediumQuestion = (question: ReviewEntryQuestion): boolean =>
  getQuestionSeverity(question) === ReviewEntryQuestionSeverity.Medium

export const isLowQuestion = (question: ReviewEntryQuestion): boolean =>
  getQuestionSeverity(question) === ReviewEntryQuestionSeverity.Low

export const hasAlertQuestion = (questions: ReviewEntryQuestion[]): boolean => questions.some(isAlertQuestion)

export const hasInputQuestion = (questions: ReviewEntryQuestion[]): boolean =>
  questions.some((question) => !isAlertQuestion(question))
